module.exports = __webpack_public_path__ + "static/media/header3.f25bcf20.jpg";